import { useCallback, useContext, useEffect } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { WorkflowV1 } from "../shared/interfaces/WorkflowV1";
import { useDataLoadingReducer } from "./DataLoadingReducer";
import { WorkflowV2 } from "../shared/interfaces/WorkflowV2";

export function useGenericWorkflowsByCustomer(customerId?: number) {
  const [state, dispatch] = useDataLoadingReducer<(WorkflowV1 | WorkflowV2)[]>([]);
  const apiContext = useContext(ApiContext);

  const fetchData = useCallback(() => {
    dispatch({ type: "loading" });
    customerId &&
      apiContext.workflowApis
        .getGenericWorkflowsByCustomer(customerId)
        .then((response) => {
          if (response instanceof Error) {
            dispatch({ type: "errored", message: response.message });
          } else {
            dispatch({ type: "loaded", data: response });
          }
        })
        .catch((error) => {
          dispatch({ type: "errored", message: error });
        });
  }, [apiContext.workflowApis, dispatch, customerId]);

  useEffect(() => {
    customerId && fetchData();
  }, [customerId, fetchData]);

  return { ...state, refreshData: fetchData };
}
